let store = require("../store");
let actions = require("../actions");

let TermsAndConditionsView = require("./TermsAndConditionsView");
let PasswordRequestView = require("./PasswordRequestView");

class LoginView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      user: store.getState().user
    };
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    mc.ui.blast(null);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleStoreChange() {
    this.setState({
      user: store.getState().user
    });
  }

  setEmail(evt) {
    this.setState({
      email: evt.target.value,
      highlightEmail: false
    });
  }

  setPassword(evt) {
    this.setState({
      password: evt.target.value,
      highlightPassword: false
    });
  }

  login(evt) {
    this.setState({
      highlightEmail: false,
      highlightPassword: false
    });

    actions.login(this.state.email, this.state.password).then((function (payload) {
      if (payload.user === null) {
        this.setState({
          highlightEmail: true,
          highlightPassword: true,
          shake: true
        });

        setTimeout(this.setState.bind(this, { shake: false }), 500);
      }
    }).bind(this));

    evt.preventDefault();
  }

  forgotPassword() {
    PasswordRequestView.open(this.state.email);
  }

  render() {
    let user = this.state.user;

    if (user) {
      if (user.user.legaleseVersionAccepted < user.user.legaleseVersionRequired) {
        return <TermsAndConditionsView/>;
      }

      mc.router.trigger("STUDY_LIST_VIEW");
    }

    return (
      <div className="rc-login-view">
        <form data-shake={this.state.shake} onSubmit={this.login.bind(this)}>
          <div>
            <input
              name="email"
              type="text"
              autoCorrect="off"
              autoCapitalize="off"
              value={this.state.email}
              placeholder={tx("email_address")}
              data-highlight={this.state.highlightEmail}
              onChange={this.setEmail.bind(this)}/>
          </div>
          <div>
            <input
              name="password"
              type="password"
              value={this.state.password}
              placeholder={tx("password")}
              data-highlight={this.state.highlightPassword}
              onChange={this.setPassword.bind(this)}/>
          </div>
          <button name="submit" className="mc-button" onClick={this.login.bind(this)}>
            {tx("log_in")}
          </button>
        </form>
        <button name="help" onClick={this.forgotPassword.bind(this)}>
          <small>{tx("forgot_password")}</small>
        </button>
      </div>
    );
  }
}

module.exports = LoginView;
